
import React, { useContext, useEffect, useRef, useState } from "react";
import { Row, Col, Container, Image, Dropdown, Form, Spinner } from "react-bootstrap";
import { TenantContext } from "../../context/tenant/TenantContext";
import { ClientContext } from "../../context/client/ClientContext";
import { CardContext } from "../../context/card/CardContext";

// import DOMPurify from "dompurify";
import "./tenantfooter.css";
import Skeleton from "../skeletons/Skeleton";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { offerwallapi } from "../../config/axiosconfig";
import { LanguageContext } from "../../context/language/LanguageContext";
import { OffersContext } from "../../context/offers/OffersContext";
import { CheckAuth } from "../../utils/auth";
import Cookies from "universal-cookie";

export default function TenantFooter() {
    const { language } = useContext(LanguageContext);
    const { tenant } = useContext(TenantContext);

    const params = useParams();
    const tenanturl = params.tenanturlpathname;

    return <footer id="footer" className="footer_area ow-primary-blue">
        <div className="container">
            <div className="footer_wrapper pt-50 pb-100">
                <div className="footer-content">
                    {/* <div className="footerLinks">
                        <div className="footer-linkstitle text-white">{language?.static_labels.support}</div>
                        <div className="footerLink text-white">
                            <ul className="footer-ul">
                                <li className="text-white"><a href="#">{language?.static_labels.faq}</a></li>
                            </ul>
                        </div>
                    </div> */}
                    <div className="footerLinks">
                        {/* <div className="footer-linkstitle text-white">{language?.static_labels.legalprivacy}</div> */}
                        <div className="footerLink">
                            <ul className="footer-ul">
                                {
                                    tenant?.tenantcontentconfig?.footer?.links.map((lnk) => {
                                        return <li className="text-white">
                                            <a href={lnk.link}
                                                target={lnk.target}>
                                                {lnk.text}
                                            </a>
                                        </li>

                                    })
                                }
                                {/* <li className="text-white"><Link to={`/${tenanturl}/terms`}>{language?.static_labels.termsandconditions}</Link></li>
                                <li className="text-white"><a href="https://www.visa.co.jp/legal/global-privacy-notice.html" target="_blank">{language?.static_labels.global_privacy_policy}</a></li>
                                <li className="text-white"><Link to={`/${tenanturl}/servicepolicy`}>{language?.static_labels.service_privacy_policy}</Link></li>
                                <li className="text-white"><a href="https://www.visa.co.jp/legal/global-privacy-notice/cookie-notice.html" target="_blank">{language?.static_labels.cookie_policy}</a></li>
                                <li className="text-white"><Link to={`/${tenanturl}/faq`}>{language?.static_labels.faq}</Link></li> */}
                                
                                
                                {/* <li className="text-white"><Link to={`/${tenanturl}/terms`}>{language?.static_labels.termsandconditions}</Link></li>
                                <li className="text-white"><a href="https://usa.visa.com/legal/global-privacy-notice.html" target="_blank">{language?.static_labels.global_privacy_policy}</a></li>
                                <li className="text-white"><Link to={`/${tenanturl}/servicepolicy`}>{language?.static_labels.service_privacy_policy}</Link></li>
                                <li className="text-white"><a href="https://www.visa.co.jp/legal/global-privacy-notice/cookie-notice.html" target="_blank">{language?.static_labels.cookie_policy}</a></li>
                                <li className="text-white"><Link to={`/${tenanturl}/faq`}>{language?.static_labels.faq}</Link></li> */}
                            </ul>
                        </div>
                    </div>
                </div>
                {/* <div className="copyrights">© Copyright 1996 - 2022. All Rights Reserved.</div> */}
            </div>
        </div>
    </footer>
}


